import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { Table, TableBody, TableCell, TableRow } from "../../../design/table";
import { usaStates } from "typed-usa-states";

interface SelectStateDialogProps {
  isOpen: boolean;
  onStateSelected: (state: string) => void;
  onClose: () => void;
}

const SelectStateDialog: React.FC<SelectStateDialogProps> = ({
  isOpen,
  onClose,
  onStateSelected,
}) => {
  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle className="flex items-center justify-between">
          Select State
        </DialogTitle>
        <DialogBody>
          <Table>
            <TableBody>
              {usaStates.map((state) => (
                <TableRow
                  key={state.abbreviation}
                  onClick={() => onStateSelected(state.abbreviation)}
                >
                  <TableCell className={"font-bold"}>{state.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogBody>
        <DialogActions className="justify-between"></DialogActions>
      </Dialog>
    </>
  );
};

export default SelectStateDialog;
